import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "DealSatisfied",
  "use": "DealSatisfied-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" class=\"fizz-icon-16 fizz-text-deal\" id=\"DealSatisfied\">\n  <path d=\"M29.2 15.4L16.6 2.8c-.5-.5-1.2-.8-2-.8H4.8C3.3 2 2 3.3 2 4.8v9.8c0 .8.3 1.5.8 2l12.6 12.6c.5.5 1.2.8 2 .8s1.5-.3 2-.8l9.8-9.8c.5-.5.8-1.2.8-2s-.3-1.5-.8-2zM6.9 9c-1.2 0-2.1-.9-2.1-2.1s.9-2.1 2.1-2.1S9 5.7 9 6.9 8.1 9 6.9 9z\">\n  </path>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol